import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import EllipsisStyle from '@sdk/components/ui/EllipsisStyle';
import DisplayText from '@sdk/components/ui/DisplayText';

export const Header = styled(Row)`
  min-height: 76px;
  align-items: center;
  padding: 0 20px 0 20px;
  background: ${({ theme }) => theme.colors.white};
  justify-content: space-between;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  ${EllipsisStyle}
`;

export const HeaderButtons = styled(Row)`
  align-items: center;
  max-height: 34px;
`;

export const HeaderTextContent = styled(DisplayText)`
  max-width: 420px;
  ${EllipsisStyle}
`;

export const ClickableHeaderButton = styled(Row)`
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 34px;
  width: 34px;
  opacity: 0.65;

  &:hover {
    opacity: 1;
  }

  svg {
    outline: none;
  }
`;
